module.exports = __webpack_public_path__ + "img/face8.76aa1bec.png";